// import { Bot, Image, FileText, Mic, Video } from 'lucide-react'
import ReviewsIcon from '@mui/icons-material/Reviews';
import ImageIcon from '@mui/icons-material/Image';
import TextsmsIcon from '@mui/icons-material/Textsms';
import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice';
import VideocamIcon from '@mui/icons-material/Videocam';
import { Link } from 'react-router-dom';

const AiFeature = () => {
    const features = [
    {
      icon: <ReviewsIcon className="w-8 h-8 text-purple-600" />,
      title: "Ai Chat",
      description: "Engage in intelligent conversations with our advanced AI chatbot",
      link:"/ai-chat"
    },
    {
      icon: <ImageIcon className="w-8 h-8 text-purple-600" />,
      title: "Image Generator",
      description: "Create stunning images with AI-powered generation",
      link:"/image-genrator"
    },
    {
      icon: <TextsmsIcon className="w-8 h-8 text-purple-600" />,
      title: "Speech to Text",
      description: "Convert spoken words into written text with high accuracy",
      link:"/speech-text"
    },
    {
      icon: <KeyboardVoiceIcon className="w-8 h-8 text-purple-600" />,
      title: "Voice Maker",
      description: "Generate natural-sounding voices for your content",
      link:"/voice-maker"
    },
    {
      icon: <VideocamIcon className="w-8 h-8 text-purple-600" />,
      title: "Ai Video Maker",
      description: "Create engaging videos with AI assistance",
      link:"/video-maker"
    }
  ]

  return (
    <div className="px-4 py-6">
      <div className="max-w-[100%] mx-auto">
        <h1 className="text-[26px] font-semibold text-gray-900 mb-[24px]">AI Feature</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <Link
              key={index}
              to={feature.link}
              className="bg-white rounded-xl p-6 shadow-cs cursor-pointer hover:shadow-cs transition-shadow duration-300 relative overflow-hidden group"
            >
              <div className="bg-purple-100 w-14 h-14 rounded-lg flex items-center justify-center mb-4">
                {feature.icon}
              </div>
              
              <h2 className="text-2xl font-semibold text-gray-900 mb-2">
                {feature.title}
              </h2>
              
              <p className="text-gray-600">
                {feature.description}
              </p>
              
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-purple-500 to-purple-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
};
export default AiFeature

